// extracted by mini-css-extract-plugin
export default {"disclaimers":"pdp-disclaimers"};